/**
 * @module Section-Case-Study-List
 */

import { navUrl } from "../../../globals/common-functions";
import { route } from "../../../globals/constants";
import { NavLink } from "react-router-dom";
import { TypeCase } from "../../@types/reusableTypes";
import AvertImage from "../../../globals/elements/avertimg";

const SectionCaseStudyCases = (props: {
    _cases: TypeCase[]
}) => {
    const { _cases } = props;
    return (
        <div className="av-cs-grid">
            {
                _cases.map((_item, _index) => {
                    const detailUrl = navUrl.pages(route.pages.PROJECT_DETAIL.replace(':projectId', _item.id));
                    return (
                        <div key={_index} className="wow fadeInUp" data-wow-delay={`${_index * 0.1}s`}>
                            <div className="av-cs-card">
                                <div className="av-cs-img">
                                    <NavLink to={detailUrl}>
                                        <AvertImage src={_item.image} alt={`${_item.subtitle} - Anathoth Technologies`} />
                                    </NavLink>
                                    <div className="av-cs-overlay"></div>
                                    <NavLink to={detailUrl} className="av-cs-arrow">
                                        <i className="feather feather-arrow-up-right" />
                                    </NavLink>
                                </div>
                                <div className="av-cs-body">
                                    <div className="av-cs-cats">
                                        {
                                            _item.categories.map((_category, _catIndex) => (
                                                <NavLink to={navUrl.pages(route.pages.CASE_STUDY)} key={_catIndex} className="av-cs-cat">
                                                    {_category}
                                                </NavLink>
                                            ))
                                        }
                                    </div>
                                    <NavLink to={detailUrl} className="av-cs-title">
                                        <h3 className="av-cs-title">{_item.subtitle}</h3>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default SectionCaseStudyCases;
